import { HttpProgressEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { DocumentApiService } from '@api-services/document-api.service';
import { Document } from '@models/document';

import { UploadFileService } from '../upload-file-service.base';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentService extends UploadFileService {
  selectedDocumentCategoryId: number;

  constructor(private documentApiService: DocumentApiService) {
    super();
  }

  uploadDocumentObs(file: File): Observable<Document | HttpProgressEvent> {
    return this.documentApiService.uploadDocument(this.selectedDocumentCategoryId, file);
  }
}
